import React from "react";

// Generic white rounded card shell used across every TSP dashboard widget.
// Keeps title/subtitle/action layout consistent so section components only
// need to supply content.
const TspCard = React.forwardRef(function TspCard(
  { title, subtitle, action, className = "", bodyClassName = "", children },
  ref
) {
  return (
    <div ref={ref} className={`tsp-card ${className}`}>
      {(title || action) && (
        <div className="tsp-card-header">
          <div>
            {title && <h3 className="tsp-card-title">{title}</h3>}
            {subtitle && <p className="tsp-card-subtitle">{subtitle}</p>}
          </div>
          {action && <div className="tsp-card-action">{action}</div>}
        </div>
      )}
      <div className={`tsp-card-body ${bodyClassName}`}>{children}</div>
    </div>
  );
});

export default TspCard;
